
type RedemptionStatus = {
    value: 'pending' | 'redeemed ';
    label: string;
};

type SourceType = {
    value: string;
    label: string;
    selectAll?: boolean;
};

type VisitorType = {
    value: string;
    label: string;
    selectAll?: boolean;
};

type VerifiedData = {
    value: string;
    label: string;
};

interface FormSelectConstants {
    redemptionStatus: RedemptionStatus[];
    sourceTypes: SourceType[];
    visitorType: VisitorType[];
    verifiedData: VerifiedData[];
}

const FormSelectConstants: FormSelectConstants = {
    redemptionStatus:[
        {label: "redeemed",value: "redeemed"},
        {label: "pending",value: "pending"}
    ],
    verifiedData:[
        {label: "Y",value: "Y"},
        {label: "N",value: "N"}
    ],
    sourceTypes:[
        { label: "All", value: "all", selectAll: true },
        { label: "Onsite [01]", value: "01" },
        { label: "ORS [02]", value: "02" },
        { label: "ORS Mobile [03]", value: "03" },
        { label: "VMS [04]", value: "04" },
        { label: "VMS Mobile [05]", value: "05" },
        { label: "Hotel Kiosks [06]", value: "06" },
        { label: "Self Service Kiosks [07]", value: "07" },
        { label: "DATES [08]", value: "08" },
        { label: "Visitor Promotion [09]", value: "09" },
        { label: "Overseas Office [10]", value: "10" },
        { label: "Non-TDC Events [11]", value: "11" },
        { label: "OCRS [12]", value: "12" },
        { label: "SORS [13]", value: "13" },
        { label: "EBBE [14]", value: "14" },
        { label: "VEP [17]", value: "17" },
        { label: "VEP AOR [19]", value: "19" }
    ],
    visitorType:[
        { label: "All", value: "all", selectAll: true },
        { label: "Onsite Registered Visitor [00]", value: "00" },
        { label: "Visitor [01]", value: "01" },
        { label: "No Show Pre-reg Buyers [02]", value: "02" },
        { label: "Past Visitor (Last year) [03]", value: "03" },
        { label: "Past Visitor (2 years ago) [04]", value: "04" },
        { label: "Past Visitor (3 years ago) [05]", value: "05" },
        { label: "Past Visitor (Frequent Company) [06]", value: "06" },
        { label: "Past Visitor (Frequent Buyer) [07]", value: "07" },
        { label: "Past Visitor (Alternate fair - last year) [08]", value: "08" },
        { label: "Past Buyer - Dormant (Alternate Edition) [09]", value: "09" },
        { label: "Past Buyer - Dormant (Past 4 yrs or up buyers) [10]", value: "10" },
        { label: "Potential Buyers? (Never register/ Event Code/ Product Code) [11]", value: "11" },
        { label: "Airport Buffer Hall Visitor [12]", value: "12" },
        { label: "Octopus Cards (Premier Cards Programme) Visitor [13]", value: "13" },
        { label: "Roadshow Enquiry [14]", value: "14" },
        { label: "VP - Asia Miles [15]", value: "15" },
        { label: "VP - Buying Mission [16]", value: "16" },
        { label: "VP - Carpet Coverage [17]", value: "17" },
        { label: "VP - Dragon Lounge [18]", value: "18" },
        { label: "VP - Local TM [19]", value: "19" },
        { label: "VP - Offsite [20]", value: "20" },
        { label: "VP - Sponsored Buyer [21]", value: "21" },
        { label: "Top Importer [22]", value: "22" },
        { label: "Google SEM [33]", value: "33" },
        { label: "Internal SMS [34]", value: "34" },
        { label: "Facebook Channel Visitor [35]", value: "35" },
        { label: "eDM Channel Visitor [36]", value: "36" },
        { label: "Special Events Visitor [37]", value: "37" },
        { label: "Contingency Barcode Visitor [38]", value: "38" },
        { label: "LinkedIn Channel Visitor [39]", value: "39" },
        { label: "Gmail Channel Visitor [40]", value: "40" },
        { label: "Yahoo SEM Visitor [41]", value: "41" },
        { label: "Location based SMS [42]", value: "42" },
        { label: "WeChat Channel Visitor [43]", value: "43" },
        { label: "Baidu SEM [44]", value: "44" },
        { label: "Print Ad Visitor [45]", value: "45" },
        { label: "Banner Ad Visitor [46]", value: "46" },
        { label: "Mobile advertorial Visitor [47]", value: "47" },
        { label: "Event Listing Site Visitor [48]", value: "48" },
        { label: "Other Channels Visitor [49]", value: "49" },
        { label: "VIP [61]", value: "61" },
        { label: "VIP - Dragon Lounge [62]", value: "62" },
        { label: "VIP - Speaker [63]", value: "63" },
        { label: "Speaker [74]", value: "74" },
        { label: "Guest [75]", value: "75" },
        { label: "Oversea Delegation [76]", value: "76" },
        { label: "Mainland Delegation [77]", value: "77" },
        { label: "Exhibitor [80]", value: "80" },
        { label: "Exhibitor (Storage) [81]", value: "81" },
        { label: "Advisor [A2]", value: "A2" },
        { label: "Co-Organiser/ JV Organiser/ Supporting Organiser [A3]", value: "A3" },
        { label: "Staff [A1]", value: "A1" },
        { label: "Partner [A4]", value: "A4" },
        { label: "Media/Press/Journalist [60]", value: "60" }
    ]
}

function getLabelByValue(field: string, value: string): string | null {
    const options = FormSelectConstants[field];
    if (!options) return null;

    const match = options.find(option => option.value === value);
    return match ? match.label : null;
}

const validateReadableRefIdLength = (value: ?string) => {
    const message = `Please input 12 characters only.`;
    if (!value) {
        return undefined;
    } else {
        if (value.length < 12) {
            return message;
        } else {
            return undefined;
        }
    }
};


export default FormSelectConstants;
export { getLabelByValue ,validateReadableRefIdLength };


// WEBPACK FOOTER //
// ./src/components/constants/SearchFormConstants.js